export const isArray = (x: any): x is Array<any> => Array.isArray(x);

// deno-lint-ignore ban-types
export const isFn = (x: any): x is Function => typeof x == "function";

export const isStringy = (x: any): x is string => typeof x === "string" || typeof x === "number";

export const isNully = (x: any): x is null => x === null || x === false || typeof x === "undefined";

export const isEvent = (el: any, p: string) => 0 === p.toLowerCase().indexOf("on");
